// extracted by mini-css-extract-plugin
module.exports = {"spinning":"IconLoading_spinning__HbnvH","rotate":"IconLoading_rotate__gRX9c"};